var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('OperationDialog',{attrs:{"show":_vm.showDialog,"opera-info":_vm.operaInfo,"show-content":false,"cancel":false,"show-close":false},on:{"confirm":_vm.handelConfirm}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }